import React, {Component} from 'react';
import qs from 'qs';
import styled from 'styled-components';
import {Button} from '@betareader/design-system';
import {withRouter} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {updateReaderFilters} from '../../modules/readerIndex';
import ReaderIndexFilter from './readerIndexFilter';

const FilterPanel = styled.section`
  border: 1px solid var(--br-border);
  border-radius: var(--br-control-radius);
  padding: var(--br-space-3);
`;

const FilterList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export class ReaderIndexFilterContainer extends Component {
  state = {showReaderFilters: false};

  componentDidMount() {
    const query = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
    if (Array.isArray(query.filter)) this.updateFilterList(query.filter);
  }

  addFilter = index => {
    const filters = [...(this.props.readerFilters || [{}])];
    filters.splice(index + 1, 0, {});
    this.updateFilterList(filters);
  };

  removeFilter = index => {
    const filters = [...(this.props.readerFilters || [])];
    filters.splice(index, 1);
    if (filters.length === 0) {
      filters.push({});
      this.setState({showReaderFilters: false});
    }
    this.updateFilterList(filters);
  };

  handleFilterChange = ({index, type, option, value}) => {
    const filters = [...(this.props.readerFilters || [{}])];
    filters[index] = type === 'any' ? {} : {type, option, value};
    this.updateFilterList(filters);
  };

  updateFilterList = filters => {
    this.props.updateReaderFilters(filters, success => {
      if (!success) return;
      const {history, onUpdate} = this.props;
      history.replace(`${history.location.pathname}${qs.stringify({filter: filters}, {addQueryPrefix: true})}`);
      onUpdate();
    });
  };

  getFilterText = () => {
    const {readerFilters, t} = this.props;
    if (!readerFilters?.length || (readerFilters.length === 1 && Object.keys(readerFilters[0]).length === 0)) {
      return t('AddFilter');
    }
    return `${readerFilters.length} ${t('Filters')}`;
  };

  toggleReaderFilters = () => this.setState(({showReaderFilters}) => ({showReaderFilters: !showReaderFilters}));

  render() {
    const {showReaderFilters} = this.state;
    const {readerFilters, t} = this.props;
    return (
      <div style={{width: '100%'}}>
        {!showReaderFilters && (
          <Button type='button' variant='secondary' aria-expanded='false' onClick={this.toggleReaderFilters}>
            {this.getFilterText()}
          </Button>
        )}
        {showReaderFilters && (
          <FilterPanel aria-label={t('Filters')}>
            <Button type='button' variant='secondary' aria-expanded='true' onClick={this.toggleReaderFilters}>
              {t('Filters')} ↑
            </Button>
            <FilterList>
              {(readerFilters || [{}]).map((filter, index) => (
                <React.Fragment key={index}>
                  {index > 0 && <li aria-hidden='true' style={{paddingTop: 'var(--br-space-2)'}}>{t('And')}</li>}
                  <ReaderIndexFilter
                    index={index}
                    type={filter.type}
                    option={filter.option}
                    value={filter.value}
                    removeFilter={this.removeFilter}
                    addFilter={this.addFilter}
                    handleFilterChange={this.handleFilterChange}
                  />
                </React.Fragment>
              ))}
            </FilterList>
          </FilterPanel>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  readerFilters: state.readerIndex.readerFilters,
});

const mapDispatchToProps = dispatch => bindActionCreators({updateReaderFilters}, dispatch);

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(ReaderIndexFilterContainer)));
